<template>
    <div>
        <span class="text-xl text-red-700">
            <span v-show="isFavorite" @click.prevent="toggleAddToFavorites"><i class="fas fa-heart"></i></span>
            <span v-show="! isFavorite" @click.prevent="toggleAddToFavorites"><i class="far fa-heart"></i></span>
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    guest: Boolean,
    offer: Object,
    favorite: Boolean
});

const emit = defineEmits(['show-register-modal', 'update:favorite']);

/**
 * determine if offer is Favorite
 */
const isFavorite = computed(() => props.favorite);

/**
 * add offer to favorites
 */
const addToFavorites = () => {
    axios.post(`/web-api/offer/${props.offer.id}/favorites`)
        .then(response => {
            emit('update:favorite', true);
        })
        .catch(error => {
            // console.log(error)
        });
};

/**
 * remove offer from favorites
 */
const removeFromFavorites = () => {
    axios.delete(`/web-api/offer/${props.offer.id}/favorites`)
        .then(response => {
            emit('update:favorite', false);
        })
        .catch(error => {
            // console.log(error)
        });
};

/**
 * toggle add to favorites setting
 */
const toggleAddToFavorites = () => {
    if (props.guest) {
        emit('show-register-modal', 'favorites');
        return;
    }

    if (props.favorite) {
        removeFromFavorites();
    } else {
        addToFavorites();
    }
};
</script>
